// extracted by mini-css-extract-plugin
export default {"customTooltip":"BarChart_customTooltip__wCqlr","customTooltip--bar":"BarChart_customTooltip--bar__goTub"};